import TabsBroadcastChannel from '@/shared/legacy/lib/tabsBroadcast/tabsBroadcast';
import { createWebsocketPoller } from './websocket-poller';

export function createAsyncConnect({ pollerUrl, accountMemberId }: {
  pollerUrl: string;
  accountMemberId: number;
}) {
  const broadcastChannel = new TabsBroadcastChannel(accountMemberId);
  const poller = createWebsocketPoller(pollerUrl.replace('https', 'wss').replace('http', 'ws'), broadcastChannel);

  const result = {
    close: () => {
      poller.close();
      return result;
    },
    recreate: () => {
      poller.recreate();
      return result;
    }
  };
  return result;
}
